const indices = [
  { title: '国产都市情感剧场', desc: '都市爱情、家庭伦理、职场励志精选', count: '326部', icon: 'ri-building-2-line' },
  { title: '韩流热播精选', desc: '最新韩剧同步更新，甜蜜虐心全收录', count: '218部', icon: 'ri-heart-pulse-line' },
  { title: '欧美高分悬疑', desc: '烧脑推理、犯罪惊悚，口碑佳作', count: '195部', icon: 'ri-search-eye-line' },
  { title: '古装仙侠巨制', desc: '玄幻修真、武侠江湖视觉盛宴', count: '287部', icon: 'ri-sword-line' },
  { title: '日剧治愈时光', desc: '温暖细腻的日式剧情，治愈心灵', count: '142部', icon: 'ri-sun-line' },
  { title: '动画动漫专区', desc: '热门国漫日漫美漫，全年龄段覆盖', count: '403部', icon: 'ri-movie-2-line' },
  { title: '纪录探索发现', desc: '自然人文科技纪录片，拓展视野', count: '168部', icon: 'ri-earth-line' },
  { title: '综艺娱乐合集', desc: '热门综艺、脱口秀、真人秀一网打尽', count: '256部', icon: 'ri-emotion-laugh-line' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-12 md:py-16 bg-background-100 scroll-mt-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3">
          精选专题
        </h2>
        <p className="text-sm text-foreground-600 text-center mb-8 max-w-xl mx-auto">
          按题材精心分类，快速找到你想看的剧集类型
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {indices.map((item, i) => (
            <a
              key={i}
              href="#ranking"
              className="group bg-background-50 rounded-lg p-5 border border-background-200/70 hover:border-primary-200 transition-all duration-200 cursor-pointer"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-50 text-primary-500 mb-3 group-hover:bg-primary-100 transition-colors duration-200">
                <i className={`${item.icon} text-lg`}></i>
              </div>
              <h3 className="font-heading text-base font-semibold text-foreground-950 mb-1">{item.title}</h3>
              <p className="text-xs text-foreground-600 mb-3">{item.desc}</p>
              <span className="text-xs font-medium text-primary-500 bg-primary-50 px-2 py-1 rounded">
                {item.count}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}